import React from "react";
import DatePicker, { ReactDatePickerProps as OriginalProps } from "react-datepicker";
import { Popper } from "@material-ui/core";

const origRender = DatePicker.prototype.render;
const origSetOpen = DatePicker.prototype.setOpen;

type Props = OriginalProps & {
  withMuiPopper?: boolean;
};

DatePicker.prototype.render = function () {
  if (this.props.withMuiPopper) {
    return (
      <div>
        <div className="react-datepicker__input-container">
          {this.renderDateInput()}
          {this.renderClearButton()}
        </div>

        {this.state.open && (
          <Popper
            open={this.state.open}
            anchorEl={this.input}
            // perfect positioning:
            style={{ zIndex: 9999 }}
            placement="bottom-start"
            modifiers={{
              keepTogether: { enabled: false },
              offset: { enabled: true, offset: "0 5" }
            }}
          >
            {this.renderCalendar()}
          </Popper>
        )}
      </div>
    );
  }

  return origRender.call(this);
};

(DatePicker.prototype as any).setOpen = function (open: boolean, manual: boolean) {
  if (!manual) {
    return;
  }

  origSetOpen(open);
};

export default DatePicker as unknown as React.ClassicComponentClass<Props>;
